import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Link to="/" className="inline-block">
              <span className="text-3xl md:text-4xl font-heading font-black text-background-50">
                黑料<span className="text-primary-400">718</span>
              </span>
            </Link>
            <p className="mt-6 text-sm text-foreground-200 leading-relaxed max-w-sm">
              黑料718官网——您的一站式吃瓜爆料平台。每日更新最新娱乐圈八卦、网红爆料、社会热点资讯，提供黑料718最新地址入口及APP下载。吃瓜，我们是最认真的。
            </p>
            <div className="flex items-center gap-4 mt-6">
              {[
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-wechat-line', label: '微信' },
                { icon: 'ri-tiktok-line', label: '抖音' },
                { icon: 'ri-bilibili-line', label: 'B站' },
              ].map((social) => (
                <a
                  key={social.label}
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-300 hover:text-primary-400 hover:border-primary-400 transition-all duration-200 cursor-pointer"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-label font-semibold uppercase tracking-wider text-foreground-400 mb-5">
              快速导航
            </h4>
            <div className="flex flex-col gap-3">
              {[
                { to: '/', label: '首页' },
                { to: '/category/celebrity-gossip', label: '明星八卦' },
                { to: '/category/influencer-expose', label: '网红爆料' },
                { to: '/category/social-hot-topics', label: '社会热点' },
                { to: '/category/variety-show-drama', label: '综艺吃瓜' },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-label font-semibold uppercase tracking-wider text-foreground-400 mb-5">
              联系我们
            </h4>
            <div className="space-y-4">
              <div>
                <p className="text-xs text-foreground-400 mb-1">地址</p>
                <p className="text-sm text-foreground-200">中国北京市朝阳区望京SOHO T3-B座 2806室</p>
              </div>
              <div>
                <p className="text-xs text-foreground-400 mb-1">电话</p>
                <p className="text-sm text-foreground-200">+86 400-718-0001</p>
              </div>
              <div>
                <p className="text-xs text-foreground-400 mb-1">邮箱</p>
                <p className="text-sm text-foreground-200">hello@qinglianhb.cn</p>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20a%20news%20app%20interface%20with%20Chinese%20text%2C%20dark%20minimalist%20UI%2C%20clean%20design%2C%20mobile%20app%20mockup%20on%20a%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20modern%20tech%20lifestyle&width=400&height=500&seq=footer-app-qr&orientation=portrait"
                alt="黑料718 APP界面展示"
                title="黑料718 APP 吃瓜爆料平台"
                className="w-full h-48 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 黑料718 Heiliao718.com 版权所有 | 
            <a href="http://qinglianhb.cn/" target="_blank" rel="nofollow" className="hover:text-primary-400 transition-colors ml-1">京ICP备2024000001号</a>
          </p>
          <div className="flex items-center gap-5">
            {[
              { to: '/about', label: '关于我们' },
              { label: '隐私政策', to: '#' },
              { label: '用户协议', to: '#' },
            ].map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}